import { IRegistryInvoice } from "dto/Invoices/IRegistryInvoice";
import { IRegistryInvoicePrefill } from "dto/Invoices/IRegistryInvoicePrefill";
import InvoiceRegistryForm from "components/CreateRegistryEntryModal/InvoiceRegistryForm";
import InvoicePdfSlide from "./InvoicePdfSlide";

interface Props {
  invoice: IRegistryInvoice;
  prefill?: IRegistryInvoicePrefill;
  onClose: () => void;
  onBookNext?: () => void;
  onBooked?: () => void;
}

const BookingSlide = ({ invoice, prefill, onClose, onBookNext, onBooked }: Props) => (
  <InvoicePdfSlide invoice={invoice} title="Faktura/Rachunek — Księgowanie" onClose={onClose}>
    <InvoiceRegistryForm
      onClose={onClose}
      hideFileSection
      prefill={prefill}
      onBookNext={onBookNext}
      onBooked={onBooked}
    />
  </InvoicePdfSlide>
);

export default BookingSlide;
